import { toAccountId } from '@atlassian/jira-shared-types/src/general.tsx';
import type { Approver, DefaultApprover, PeopleFieldUser } from '../common/types.tsx';
import type { FetchedUser } from '../services/approver-service/types.tsx';

export const fetchedUserToApprover = (fetchedUser: FetchedUser): Approver => ({
	name: fetchedUser.displayName,
	avatarUrl: fetchedUser.avatarUrls['48x48'],
	accountId: toAccountId(fetchedUser.accountId),
	type: 'user',
});

export const approverToPeopleFieldUser = (approver: Approver): PeopleFieldUser => ({
	id: approver.accountId.toString(),
	name: approver.name || '',
	type: approver.type,
	fixed: false,
	avatarUrl: approver.avatarUrl || '',
});

export const peopleFieldUserToApprover = (peopleFieldUser: PeopleFieldUser): Approver => ({
	name: peopleFieldUser.name,
	avatarUrl: peopleFieldUser.avatarUrl,
	accountId: toAccountId(peopleFieldUser.id),
	type: peopleFieldUser.type === 'user' ? 'user' : 'team',
});

export const approverToDefaultApprover = (approver: Approver): DefaultApprover => ({
	id: approver.accountId,
	type: approver.type,
});

export const defaultApproverToApprover = (defaultApprover: DefaultApprover): Approver => ({
	accountId: defaultApprover.id,
	type: defaultApprover.type,
});
